import { Container, Row, Col, Form, Card } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "./Login.css";
import WhiteButton from "./../common_components/common_button/WhiteButton";
import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  faInstagram,
  faFacebookF,
  faXTwitter,
  faYoutube,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import Login_Succes_Lottie from "./../animation/login_succes_lottie/Login_Succes_Lottie";
import {
  sendLoginOtp,
  LoginverifyOtp,
  GETProfile,
} from "../../features/admin/auth/Slice";
import { useDispatch } from "react-redux";

export default function Signup() {
  const dispatch = useDispatch();
  const swiperRef = useRef(null);
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [showReferral, setShowReferral] = useState(false);
  const [showForgotOtp, setShowForgotOtp] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  const mobileInput = watch("mobile_number");

  const images = [
    "/images/login/formbgimg.png",
    "/images/login/formbgimg2.png",
  ];

  /* OTP STATE */
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);

  /* TIMER */
  useEffect(() => {
    let interval;

    interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    if (timer === 0) {
      setCanResend(true);

      // ✅ clear error + otp
      setOtp(["", "", "", ""]);
      setOtpError("");
    }

    return () => clearInterval(interval);
  }, [timer, step]);

  /* OTP INPUT */
  const handleOtpChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // ✅ CLEAR ERROR when user types
      if (otpError) {
        setOtpError("");
      }

      if (value && index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  /* RESEND OTP */
  const handleResendOtp = async () => {
    try {
      const res = await dispatch(
        sendLoginOtp({ mobile_number: phone }),
      ).unwrap();

      if (res?.success) {
        setTimer(30);
        setCanResend(false);

        // ✅ clear everything
        setOtp(["", "", "", ""]);
        setOtpError(""); // ✅ ADD THIS
        inputRefs.current[0]?.focus();
      }
    } catch (error) {
      console.log(error);
    }
  };

  /* VERIFY OTP */
  const submitForm = async (e) => {};

  /* SUCCESS REDIRECT */
  useEffect(() => {
    if (step === 3) {
      const timer = setTimeout(() => {
        navigate("/home");
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [step, navigate]);

  const onSubmit = async (data) => {};

  useEffect(() => {
    if (otp.every((digit) => digit === "")) {
      setOtpError("");
    }
  }, [otp]);

  return (
    <div className="login-wrapper">
      <Swiper
        modules={[EffectFade, Autoplay, Navigation]}
        effect="fade"
        autoplay={{ delay: 3000 }}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        loop
        className="login-swiper"
      >
        {images.map((img, i) => (
          <SwiperSlide key={i}>
            <div
              className="bg-slide"
              style={{ backgroundImage: `url(${img})` }}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <Container fluid className="login-overlay  container">
        <Row className="align-items-center h-100 ">
          {/* LEFT SIDE */}
          <Col
            xs={12}
            md={6}
            lg={6}
            className="contain-card text-white ps-lg-5 login-left"
          >
            <h1 className="signup-login">Sign Up</h1>

            <h1 className="fw-bold my-4 sub-title">
              Empower your network,
              <br />
              grow your business.
            </h1>

            <p className="fst-italic expand ">
              Expand reach. Multiply success.
            </p>

            <div className="custom-nav">
              <div
                className="custom-prev"
                onClick={() => swiperRef.current?.slidePrev()}
              >
                <FontAwesomeIcon icon={faAngleLeft} />
              </div>

              <div
                className="custom-next"
                onClick={() => swiperRef.current?.slideNext()}
              >
                <FontAwesomeIcon icon={faAngleRight} />
              </div>
            </div>

            <div className="social-icon">
              <a href="https://instagram.com">
                <FontAwesomeIcon className="icon" icon={faInstagram} />
              </a>

              <a href="https://facebook.com">
                <FontAwesomeIcon className="icon" icon={faFacebookF} />
              </a>

              <a href="https://twitter.com">
                <FontAwesomeIcon className="icon" icon={faXTwitter} />
              </a>

              <a href="https://youtube.com">
                <FontAwesomeIcon className="icon" icon={faYoutube} />
              </a>

              <a href="https://linkedin.com">
                <FontAwesomeIcon className="icon" icon={faLinkedinIn} />
              </a>
            </div>
          </Col>

          <Col
            xs={12}
            md={6}
            lg={6}
            className="d-flex justify-content-center right-form"
          >
            <Card className="login-card border-0">
              <Card.Body className="card-body p-4 text-center">
                <img
                  className="main-logo"
                  src="images/logo/logo.png"
                  alt="Spirulina"
                />
                <h6 className="welcome-title">Sign Up</h6>

                <Form
                  className="mt-3 input-form"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  {step === 1 && (
                    <>
                      <div className="phone-input-wrapper">
                        <Form.Control
                          maxLength={10}
                          className="rounded-pill mb-2 input-filed pe-5"
                          placeholder="Enter Contact No."
                          disabled={
                            step === 2 && mobileInput === phone && timer > 0
                          }
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              "",
                            );
                          }}
                          onChange={(e) => {
                            const value = e.target.value;

                            if (step === 2 && timer === 0 && value !== phone) {
                              setStep(1);
                              setOtp(["", "", "", ""]);
                              setShowReferral(false);
                              setMobileError("");
                              setOtpError("");
                              setCanResend(false);
                            }
                          }}
                          {...register("mobile_number", {
                            required: "Phone is required",
                            pattern: {
                              value: /^[0-9]{10}$/,
                              message: "Enter valid 10 digit number",
                            },
                          })}
                        />
                      </div>

                      {!showForgotOtp && (
                        <WhiteButton
                          className="center-btn submit-otp-button"
                          title={"Send OTP"}
                          bg="#000"
                          color="#f35f37"
                          hoverColor="#f35f37"
                          hoverBg={"#000"}
                          type="button"
                          onClick={() => setShowForgotOtp(true)}
                        />
                      )}

                      {showForgotOtp && (
                        <>
                          <div className="d-flex otp-box justify-content-center gap-3 mb-3 mt-3">
                            {otp.map((digit, idx) => (
                              <Form.Control
                                key={idx}
                                ref={(el) => (inputRefs.current[idx] = el)}
                                type="text"
                                maxLength={1}
                                value={digit}
                                onChange={(e) =>
                                  handleOtpChange(idx, e.target.value)
                                }
                                onKeyDown={(e) => handleKeyDown(idx, e)}
                                className="otp-input text-center rounded"
                                required
                              />
                            ))}
                          </div>

                          <small className="d-block did-receive">
                            Didn't Receive OTP?{" "}
                            {canResend ? (
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleResendOtp();
                                }}
                              >
                                <strong className="resed">Resend Now!</strong>
                              </a>
                            ) : (
                              <span>Resend in {timer}s</span>
                            )}
                          </small>

                          <WhiteButton
                            className="center-btn submit-otp-button"
                            title={"Submit OTP"}
                            bg="#000"
                            color="#f35f37"
                            hoverColor="#f35f37"
                            hoverBg={"#000"}
                            type="button"
                            onClick={() => {
                              setStep(2);
                              setShowForgotOtp(false);
                            }}
                          />
                        </>
                      )}
                    </>
                  )}

                  {step === 2 && (
                    <>
                      <Form.Control
                        type="password"
                        className="rounded-pill mb-2 input-filed"
                        placeholder="Enter Password"
                      />

                      <Form.Control
                        type="password"
                        className="rounded-pill mb-2 input-filed"
                        placeholder="Enter Confirm Password"
                      />

                      <Form.Control
                        type="text"
                        className="rounded-pill mb-2 input-filed"
                        placeholder="Enter Referal Code"
                      />

                      <WhiteButton
                        className="center-btn submit-otp-button"
                        title={"Sign Up"}
                        bg="#000"
                        color="#f35f37"
                        hoverColor="#f35f37"
                        hoverBg={"#000"}
                        type="button"
                        onClick={() => navigate("/")}
                      />
                    </>
                  )}

                  <div className="signup-wrapper text-center mt-3">
                    <span>
                      Already have an account?{" "}
                      <a href="/" className="signup-link">
                        Log in
                      </a>
                    </span>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
